import { useMemo } from "react"
import { useSelector } from "react-redux"
import fp from "lodash/fp"

import { selectCurrentOrgId } from "features/store/orgSlice"
import { useTowerQuery } from "features/api"
import { getGeohash } from "helpers/utils/common"

interface useTowerProps {
  id: number | undefined | null
}

const useTower = ({ id }: useTowerProps) => {
  const orgId = useSelector(selectCurrentOrgId)

  const {
    currentData: tower,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  } = useTowerQuery(
    {
      id: Number(id),
      params: { org_id: Number(orgId) },
    },
    {
      skip: !orgId || !id,
    },
  )

  const towerGeohash = useMemo(() => {
    const lat = tower?.geo_location?.latitude
    const lon = tower?.geo_location?.longitude
    const validCoords = lat !== undefined && lon !== undefined
    return validCoords ? getGeohash(lat, lon) : undefined
  }, [tower])

  const towerById = useMemo(() => (tower ? fp.indexBy("id", [tower]) : {}), [tower])

  return { tower, towerById, towerGeohash, isFetching, isLoading, isError, isSuccess }
}

export default useTower
